import useUserStore from "stores/user";

export const logout = () => {
  const setUser = useUserStore.getState().setUser;

  //  Clear user data in state
  setUser(() => {
    return {
      isAuthorized: false,
      isAuthorizationChecked: true,
      userData: {},
    };
  });

  //  Clear user data in localStorage
  localStorage.setItem("userData", JSON.stringify({}));
};
